import Image from 'next/image';

const Stores = ({size}: {size: 'small' | 'large'}) => {
  const dimensions = {
    small: {width: 100, height: 20},
    large: {width: 120, height: 40},
  };

  const {width, height} = dimensions[size];

  return (
    <div className="flex items-center gap-3">
      <Image src="/images/playstore.png" alt="playstore" width={width} height={height} className="rounded-[4px]" />
      <Image src="/images/appstore.png" alt="appstore" width={width} height={height} className="rounded-[4px]" />
    </div>
  );
};

export default Stores;
